<script>
import {isArray} from 'lodash'
import CardNewsItem from './CardNewsItem'
import {STATUS_PIX_COBRANCA_ATIVA, STATUS_PIX_COBRANCA_CONCLUIDA} from '../../../../../domain/grv/helpers/pix'
import {consultaPixManual, gerarCodigoPix} from '../../../../../domain/grv/services'
import QRCode from 'qrcode'
import {VMoney} from 'v-money'
import {VueMaskDirective as mask} from 'v-mask'
import {REAL_BRL} from '../../../../../utils/helpers/money'
import AclCheckMixins from '../../../../_default/components/mixins/AclCheckMixins'

export default {
  name: 'CardNewsItemPagamento',
  directives: {mask, money: VMoney},
  mixins: [AclCheckMixins],
  components: {CardNewsItem},
  props: {
    calculo: {
      type: Object
    },
    preretiradas: {},
    grvId: {
      type: Number
    },
    grvPatioPix: {
      type: String
    },
    prospsTxid: {
      type: String
    }
  },
  data () {
    return {
      money: REAL_BRL,
      statusPix: null,
      descricaoPix: '',
      STATUS_PIX_COBRANCA_ATIVA,
      STATUS_PIX_COBRANCA_CONCLUIDA,
      qrCodeBase64: null,
      valorPixManual: 0.0,
      txid: null,
      isPixManual: false
    }
  },
  computed: {
    pixStatusClass () {
      if (!this.descricaoPix) return ''
      if (this.descricaoPix.includes('text-success')) return 'pix-msg pix-msg-success'
      if (this.descricaoPix.includes('text-warning')) return 'pix-msg pix-msg-warning'
      if (this.descricaoPix.includes('text-danger')) return 'pix-msg pix-msg-danger'
      return 'pix-msg'
    },
    somaPagamentos () {
      if (!isArray(this.preretiradas) || this.preretiradas.length === 0) return 0
      let totalPago = 0
      this.preretiradas.forEach((e) => {
        if (parseInt(e.status) === 1) {
          totalPago = Number(totalPago) + Number(e.valor)
        }
      })
      return totalPago
    }
  },
  methods: {
    async geraCodigoPix () {
      if (!this.grvPatioPix || this.grvPatioPix.trim() === '') {
        this.descricaoPix = '<i class="fa fa-exclamation-circle text-danger"></i> A chave Pix do pátio precisa estar cadastrada antes de gerar o código.'
        return
      }

      const valor = parseFloat(this.valorPixManual.replace(/^\D*/, '').replace(/\./, '').replace(/,/, '.'))
      if (isNaN(valor) || valor <= 0) {
        this.descricaoPix = '<i class="fa fa-check-circle text-danger"></i> Insira um valor válido antes de gerar o Pix.'
        return
      }

      try {
        this.$loaderOverlay.open().message('Criando PIX, aguarde...')
        const response = await gerarCodigoPix(this.grvId, valor, this.grvPatioPix)
        const payload = response.data.payload
        this.txid = response.data.txid
        this.qrCodeBase64 = await QRCode.toDataURL(payload)
        this.descricaoPix = '<i class="fa fa-check-circle text-success"></i> Pix gerado com sucesso!'
        this.statusPix = this.STATUS_PIX_COBRANCA_ATIVA
      } catch (error) {
        console.error('Erro ao gerar QR Code PIX:', error)
        this.descricaoPix = '<i class="fa fa-check-circle text-danger"></i> Erro ao gerar QR Code.'
      } finally {
        this.$loaderOverlay.hide()
      }
    },

    async getPixStatus () {
      if (!this.txid) {
        this.descricaoPix = '<i class="fa fa-check-circle text-danger"></i> Primeiro gere um Pix para poder consultar o status.'
        return
      }

      try {
        this.$loaderOverlay.open().message('Consultando PIX, aguarde...')
        const response = await consultaPixManual(this.txid)
        const status = response.data.status
        this.statusPix = status

        if (status === this.STATUS_PIX_COBRANCA_CONCLUIDA) {
          this.descricaoPix = '<i class="fa fa-check-circle text-success"></i> Cobrança Paga!'
        } else if (status === this.STATUS_PIX_COBRANCA_ATIVA) {
          this.descricaoPix = '<i class="fa fa-refresh text-warning"></i> Cobrança ativa. Aguardando pagamento.'
        } else {
          this.descricaoPix = '<i class="fa fa-check-circle text-danger"></i> Cobrança não encontrada, cancelada ou expirada.'
        }
      } catch (error) {
        console.error('Erro ao consultar status do PIX:', error)
        this.descricaoPix = '<i class="fa fa-check-circle text-danger"></i> Erro ao consultar status.'
      } finally {
        this.$loaderOverlay.hide()
      }
    },
    print () {
      this.$nextTick(() => {
        const paraImpressao = document.querySelector('#qr-code-printer')
        console.log(paraImpressao)
        paraImpressao.classList.add('qr-printer')
        this.$nextTick(() => {
          window.print()
          setTimeout(() => {
            paraImpressao.classList.remove('qr-printer')
          }, 300)
        })
      })
    }
  },
  mounted () {
    if (this.prospsTxid) {
      this.txid = this.prospsTxid
    }
    // if (this.preretiradas && Array.isArray(this.preretiradas) && this.preretiradas.length > 0) {
    //   const ultimaPreretirada = this.preretiradas[this.preretiradas.length - 1]
    //
    //   if (Array.isArray(ultimaPreretirada.pixTransactions) && ultimaPreretirada.pixTransactions.length > 0) {
    //     const ultimaPixTransaction = ultimaPreretirada.pixTransactions[ultimaPreretirada.pixTransactions.length - 1]
    //     if (ultimaPixTransaction && ultimaPixTransaction.txid) {
    //       this.txid = ultimaPixTransaction.txid
    //     }
    //   }
    // }
  }
}
</script>

<template>
  <card-news-item title="Pagamento">
    <u-fake-loader v-if="!calculo" width="100%" class="m-t"></u-fake-loader>
    <div v-else class="row m-t">
      <div class="col-xs-12" v-if="!preretiradas">
        <div>Inicie primeiro a pré-retirada para realizar a análise do pagamento.</div>
      </div>
      <div class="col-xs-12" v-else>
        <div v-if="somaPagamentos > 0">
          <div class="row" v-for="preretirada in preretiradas" v-if="preretirada.status === 1">
            <div class="col-xs-6">{{moment(preretirada.dataPagamento.date).format('L')}}</div>
            <div class="col-xs-6 text-right font-bold">R$ {{preretirada.valor|moeda}}</div>
          </div>
          <div class="row">
            <div class="col-xs-12 m-t-n m-b-n">
              <hr class="divider"/>
            </div>
            <div class="col-xs-12 text-right">
              Total pago: <span class="m-l-xs font-bold text-success">R$ {{somaPagamentos|moeda}}</span>
            </div>
            <div class="col-xs-12 text-right">Custo <small>({{calculo.base.diarias}} diárias)</small>: <span
              class="m-l-xs font-bold text-primary">R$ {{calculo.base.custoAtualizado|moeda}}</span></div>
            <div class="col-xs-12 text-right">
              Saldo Devedor: <span class="m-l-xs font-bold" :class="calculo.base.saldoDevedor > 0 ? 'text-danger' : ''">R$ {{calculo.base.saldoDevedor|moeda}}</span>
            </div>
          </div>
        </div>
        <div v-else>
          Nenhum pagamento reconhecido. Execute a consulta de pagamento por referência e defina a pré-retirada como paga.
        </div>
        <div class="form-check m-t" style="padding-top: 7px;">
          <label for="pixManual" class="i-checks m-b-none">
            <input v-model="isPixManual" type="checkbox" id="pixManual"
                   tabindex="0" aria-checked="false"
                   aria-invalid="false"><i></i>
            Inserir PIX manualmente
          </label>
        </div>
        <br>
        <div v-if="isPixManual">
          <div class="pix-codigo" id="qr-code-printer">
            <img v-if="qrCodeBase64" :src="qrCodeBase64" alt="QR Code PIX">
            <div v-else>QR Code ainda não gerado</div>
          </div>
          <div class="center-block text-center m-t hidden-print">
            <input
              v-model.number="valorPixManual"
              v-money="money"
              class="form-control input-sm center-block"
              style="max-width: 120px; margin: 0 auto; font-size: 14px; text-align: center"
              placeholder="Valor do Pix"
              min="0.01"
              step="0.01"
            />
            <div class="m-t-xs" :class="pixStatusClass" v-html="descricaoPix"></div>
          </div>
          <div class="center-block text-center m-t-xs">
            <button class="btn btn-info btn-block" @click="geraCodigoPix">Criar PIX manual</button>
          </div>
          <div class="center-block text-center m-t-xs">
            <button class="btn btn-info btn-block" @click="getPixStatus">Checar status PIX manual</button>
          </div>
          <div class="center-block text-center m-t-xs">
            <button class="btn btn-info btn-block" @click="print">Imprimir</button>
          </div>
        </div>
<!--        <div v-if="isAdministradorExclusivo">-->
<!--          <div class="center-block text-center m-t">-->
<!--            <div class="m-t-xs" :class="pixStatusClass" v-html="descricaoPix"></div>-->
<!--          </div>-->
        </div>
      </div>
  </card-news-item>
</template>

<style scoped>
.pix-codigo {
  width: 100%;
  height: 200px;
  border: 2px solid red;
}
.pix-buttons-wrap {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.m-r-sm {
  margin-right: 5px;
}

.pix-msg-success {
  background-color: #e6ffed;
  color: #2e7d32;
  border: 1px solid #a5d6a7;
}

.pix-msg-warning {
  background-color: #fff8e1;
  color: #f9a825;
  border: 1px solid #ffe082;
}

.pix-msg-danger {
  background-color: #ffebee;
  color: #c62828;
  border: 1px solid #ef9a9a;
}

.qr-printer {
  display: block;
  position: fixed;
  width: 100%;
  height: 100%;
  max-width: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #FFFFFF !important;
  z-index: 999999999;
  padding: 40px;
  text-align: center;
}
.qr-printer .qr-code-container {
  max-width: 400px;
}
.qr-printer .show-print {
  display: none;
}
@media print {
  .qr-printer .show-print {
    display: block;
  }
  .qr-printer .hidden-print {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// CardNewsItemPagamento.vue?30361cdf